import { getActiveElement as n } from "../../../utils/helpers.js";
const c = (t) => {
  const e = n();
  return t && e ? t.contains(e) : !1;
};
export {
  c as hasFocus
};
